exports.onRouteUpdate = ({ location }) => {
  if (location.pathname === "/") {
    const topPageWrapper = document.getElementById("load");
    topPageWrapper.classList.remove("loading");
  }
};
